var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100"},[_c('NavBar'),_c('BalanceCard',{attrs:{"totalAmount":1255}}),_c('OrdersList'),_c('BottomNavBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }